import { useQuery } from "@tanstack/react-query";

const useCurrentTrialsVolunteerList = (studyCode) => {
  const userId = localStorage.getItem("uI");
  const user_id = userId - 786;
  const {
    refetch,
    isLoading,
    isError,
    error,
    isSuccess,
    data: currentTrialsVolunteerList = [],
  } = useQuery({
    queryKey: ["CurrentTrialsVolunteerList", studyCode],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/getVoluntereByStudy/${studyCode}`
      );
      const data = await res.json();
      // console.log("study code", studyCode);
      // console.log("current trials volunteers list", data.data.volunteres);
      return data.data;
    },
  });

  return [
    currentTrialsVolunteerList,
    isLoading,
    isError,
    error,
    isSuccess,
    refetch,
  ];
};

export default useCurrentTrialsVolunteerList;
